import React from 'react';
import LOOKUP from 'constants/lookup';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import Button from 'screens/components/basic/Button';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import CardSimple from 'screens/components/basic/CardSimple';

const statusOptions = [
    {
        text: "All",
        value: "None"
    },
    {
        text: "Opened",
        value: "1"
    },
    {
        text: "Closing in Progress",
        value: "2"
    },
    {
        text: "Closed",
        value: "3"
    }
];


const searchFields = (props) => {
    return (
        <CardSimple className="p-1">
            <div className="row m-0">
                {/*Search Inputs*/}
                <div className="row m-0">
                    <div className="col-sm-3">
                        <TextInput
                            name={`${props.pageName}FirstNameFilter`}
                            className="search-field"
                            label={LOOKUP.cashregister.filters.firstName.label}
                            floatingLabelText={LOOKUP.cashregister.filters.firstName.label}
                            hintText={LOOKUP.cashregister.filters.firstName.hintText}
                            maxLength={20}
                            onPressKey={props.search} />
                    </div>
                    <div className="col-sm-3">
                        <TextInput
                            name={`${props.pageName}LastNameFilter`}
                            className="search-field"
                            label={LOOKUP.cashregister.filters.lastName.label}
                            floatingLabelText={LOOKUP.cashregister.filters.lastName.label}
                            hintText={LOOKUP.cashregister.filters.lastName.hintText}
                            maxLength={20}
                            onPressKey={props.search} />
                    </div>
                    <div className="col-sm-2">
                        <DatePickerInput name={`${props.pageName}ClockInFilter`}
                            className="search-field"
                            label={LOOKUP.cashregister.filters.clockIn.label}
                            floatingLabelText={LOOKUP.cashregister.filters.clockIn.label}
                            hintText={LOOKUP.cashregister.filters.clockIn.hintText}
                        />
                    </div>
                    <div className="col-sm-2">
                        <TextInput
                            name={`${props.pageName}StationFilter`}
                            className="search-field"
                            label={LOOKUP.cashregister.filters.station.label}
                            floatingLabelText={LOOKUP.cashregister.filters.station.label}
                            hintText={LOOKUP.cashregister.filters.station.hintText}
                            onPressKey={props.search} />
                    </div>
                    <div className="col-sm-2">
                        <SelectInput
                            name={`${props.pageName}Status`}
                            className="search-field"
                            label="Status"
                            floatingLabelText="Status"
                            defaultValue="None"
                            options={statusOptions} />
                    </div>
                </div>
                {/*Buttons*/}
                <div className="search-buttons mt-1 text-right d-flex justify-content-end">
                    <Button
                        type="IconSearchButton"
                        label={LOOKUP.cashregister.filters.filterButton}
                        onTouchTap={() => props.search()}
                        className="btnNewBrandPOS"
                        id="buttonSearchCashRegister"
                    />
                    <Button
                        className="ml-2 btnCleanSearch"
                        type="IconClearButton"
                        label={LOOKUP.cashregister.filters.cleanFilterButton}
                        onTouchTap={() => props.cleanSearch()}
                    />
                </div>
                {/*
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right search-icon-container">
                    <Button className="SearchIcon IconsSearch no-bg no-shadow"
                        primary={true}
                        label="Open"
                    /> 
                        /*<Button className="ClearIcon no-bg no-shadow"
                        primary={true}
                        label="Close Register"
                        onTouchTap={() => props.openCloseRegistersDialog()} />
                    
                </div>
            */}
            </div>
        </CardSimple>
    );
};


export default searchFields;